export default [
    "marx",
    "socrates",
    "plato",
    "kant",
    "aristotle",
    "confucius",
    "misc",
]